import script from "./PlanningWholeDay.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanningWholeDay.vue?vue&type=script&setup=true&lang=js"

import "./PlanningWholeDay.vue?vue&type=style&index=0&id=2dc6a7a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc6a7a5"]])

export default __exports__